<template>
  <div>
    <CSidebarNavTitle v-if="isSectionVisible">{{ $gettext('Payments') }}</CSidebarNavTitle>

    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.accounting.transactions.list'])"
      :name="$gettext('Transactions')"
      :to="{name: 'admin.accounting'}"
      icon="cipCreditCard02"
    />

    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.accounting.chargeback.list'])"
      :name="$gettext('Disputes')"
      :to="{name: 'admin.chargebacks'}"
      icon="cipTriangleWarning"
    />

    <CSidebarNavItem
      v-if="hasAnyPerms(['orders.invoices.list'])"
      :name="$gettext('Invoices')"
      :to="{name: 'invoice.invoice'}"
      icon="cip-doc"
    />

    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.payouts.list'])"
      :name="$gettext('Admin Payouts')"
      :to="{name: 'adminPayoutList'}"
      icon="cip-wallet-02"
    />

    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.certifications.list'])"
      :name="$gettext('Certifications')"
      :to="{name: 'adminCertificationList'}"
      icon="cip-doc"
    />

    <CSidebarNavItem
      v-if="hasPerm('menu.payout')"
      :name="$gettext('Payout')"
      :to="{name: 'payout'}"
      icon="cipWallet02"
    />
  </div>
</template>

<script>
export default {
  name: 'Payments',
  computed: {
    isSectionVisible() {
      return this.hasAnyPerms([
        'menu.accounting',
        'menu.payout',
        'orders.invoices.list',
        'payout.see',
        'admin.payouts.list',
        'admin.accounting.chargeback.list',
        'admin.certifications.list',
      ])
    }
  }
}
</script>
